/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
import { Pagination } from '@nextui-org/react';

const PaginationCustom = ({
  total,
  size,
  page,
  onChangePage,
}: {
  size: 'md' | 'lg' | 'sm';
  total: number;
  page: number;
  onChangePage?: (page: number) => void;
}) => {
  return (
    <Pagination
      classNames={{
        base: 'p-0 m-0 md:p-2.5 md:-m-2.5 w-auto',
        prev: 'bg-white border-none shadow-none text-placeholder data-[hover=true]:!bg-bg-secondary',
        next: 'bg-white border-none shadow-none text-placeholder data-[hover=true]:!bg-bg-secondary',
        item: [
          'bg-transparent border-none shadow-none data-[hover=true]:!bg-bg-secondary text-text-placeholder font-medium',
        ],
        cursor: ['bg-bg-secondary text-tertiary-600 font-semibold'],
      }}
      size={size}
      page={page}
      initialPage={1}
      onChange={(page) => {
        onChangePage && onChangePage(page);
      }}
      showControls
      total={total}
      siblings={1}
      boundaries={1}
    />
  );
};

export default PaginationCustom;
